import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

export const InitSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const version = process.env.REACT_APP_VERSION;
  const deployment = process.env.REACT_APP_DEPLOYMENT;
  const env = process.env.REACT_APP_NODE_ENV;
  if (['DEV', 'PROD'].indexOf(env) !== -1){
    Sentry.init({
      dsn,
      integrations: [new Integrations.BrowserTracing()],
      debug: true,
      initialScope: {
        tags: {
          env,
          version,
          deployment
        }
      },
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
  }
}